// extracted by mini-css-extract-plugin
export var externalLink = "_5k-0";
export var internalLinkLabel = "_5k-1";